class Auth {
    constructor() {
        this.loadToken();
    }
    loadToken() {
        const token = JSON.parse(localStorage.getItem('token'));
        if (token) {
            const date_expiry = new Date(token.expiry);
            const date_today = new Date();
            if (date_expiry > date_today) {
                this.AuthStr = `Token ${token.token}`;
                this.logueado = true;
                return;
            }
        }
        this.AuthStr = false;
        this.logueado = false;
    }

    userSession() {
        return this.logueado;
    }

    getToken() {
        return this.AuthStr;
    }
}

const AuthInstance = new Auth();
export default AuthInstance;
